var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoin(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22C18.299 22 23 17.523 23 12S18.299 2 12.5 2 2 6.477 2 12s4.701 10 10.5 10z",
    fill: "#FED425"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.878a7.62 7.62 0 017.622 7.622 7.62 7.62 0 01-7.622 7.622A7.62 7.62 0 014.878 12.5 7.62 7.62 0 0112.5 4.878zM12.5 0C5.607 0 0 5.607 0 12.5S5.607 25 12.5 25 25 19.393 25 12.5 19.393 0 12.5 0z",
    fill: "#FEB445"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default ForwardRef;